// extracted by mini-css-extract-plugin
export default {"wrapper":"ip-z","response":"jp-z","error":"kp-z","disabled":"lp-z","buttons":"mp-z","feedbackQuestionSection":"np-z","yesNoWrapper":"op-z"};